<template>
  <div>
    <van-sticky v-if="!isTabBar && $route.name !== 'shareList'">
      <van-nav-bar left-arrow :title="title" @click-left="onClickLeft" />
    </van-sticky>
    <div class="container">
      <router-view />
    </div>
    <van-tabbar v-model="active" v-if="isTabBar && userInfo.isAdmin">
      <van-tabbar-item
        :name="item.routeName"
        v-for="item in navListAdmin"
        :key="item.routeName"
        :icon="item.icon"
        @click="handleClick(item)"
        >{{ item.name }}</van-tabbar-item
      >
    </van-tabbar>
    <van-tabbar v-model="active" v-if="isTabBar && !userInfo.isAdmin">
      <van-tabbar-item
        :name="item.routeName"
        v-for="item in navList"
        :key="item.routeName"
        :icon="item.icon"
        @click="handleClick(item)"
        >{{ item.name }}</van-tabbar-item
      >
    </van-tabbar>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        active: this.$route.name,
        navListAdmin: [
          { name: "看日报", routeName: "home", icon: "bookmark-o" },
          // {
          //   name: "考勤统计",
          //   routeName: "statisAttendance",
          //   icon: "bar-chart-o",
          // },
          { name: "日报统计", routeName: "statisticsDaily", icon: "clock-o" },
          // { name: "看周报", routeName: "weeklyList", icon: "bookmark-o" },
        ],
        navList: [
          { name: "写日报", routeName: "home", icon: "shield-o" },
          { name: "看日报", routeName: "todayList", icon: "bookmark-o" },
          // { name: "写周报", routeName: "writeWeekly", icon: "records" },
          // { name: "看周报", routeName: "weeklyList", icon: "description" },
        ],
      };
    },
    computed: {
      userInfo() {
        return this.$store.state.user.userInfo;
      },
      title() {
        let title = this.$route.query.metaName;
        return title || this.$route.meta.title;
      },
      isTabBar() {
        let navList = this.userInfo.isAdmin ? this.navListAdmin : this.navList;
        return navList.some((item) => item.routeName === this.$route.name);
      },
    },
    watch: {
      "$route.name": function (val) {
        this.active = val
      },
    },
    methods: {
      handleClick(item) {
        this.title = item.name;
        this.$router.push({ path: `/technical/${item.routeName}`});
      },
      onClickLeft() {
        this.$router.back();
      },
    },
  };
</script>
<style lang="scss" scoped>
  .navbar {
    position: fixed;
    top: 0;
    width: 100%;
  }
  .container {
    padding: 0 0 100px 0;
  }
</style>
